import { createEffect } from 'effector'

export const signInGithubFx = createEffect(() => {
  window.location.href = '/auth/login?provider=github'
})

export const signInGoogleFx = createEffect(() => {
  window.location.href = '/auth/login?provider=google'
})
